/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveDeviceResponse
 */
export interface ActiveDeviceResponse {
    /**
     * 
     * @type {string}
     * @memberof ActiveDeviceResponse
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveDeviceResponse
     */
    activeDevices?: number;
}

export function ActiveDeviceResponseFromJSON(json: any): ActiveDeviceResponse {
    return ActiveDeviceResponseFromJSONTyped(json, false);
}

export function ActiveDeviceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveDeviceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'activeDevices': !exists(json, 'activeDevices') ? undefined : json['activeDevices'],
    };
}

export function ActiveDeviceResponseToJSON(value?: ActiveDeviceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'activeDevices': value.activeDevices,
    };
}

